export const isFunction = (value) => typeof value === "function";

export const traceInvalidRoute = (value) => () => {
  const valueType = typeof value;
  const valueName = valueType === "function" ? value.name || "(anonymous)" : valueType;
  const stack = new Error().stack;

  console.error(
    "renderRoute received a function instead of a Route value.",
    { valueType, valueName, value }
  );
  if (stack) {
    console.error(stack);
  }

  return "/__invalid-route__";
};
